import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/')({
  beforeLoad: ({
    params
  }) => {
    throw redirect({
      to: '/software/$id/contract-and-cost/deal/contract',
      params: {
        id: params.id
      }
    });
  }
});